export default function hasAdapterAccess(entity, adapter, item = null) {
  return (
    !entity.hasAdapterAccess?.[adapter] ||
    entity.hasAdapterAccess[adapter](item)
  );
}
